import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getInvoiceIssues } from 'api/invoiceIssues/getInvoiceIssues'
import { invoiceIssuesKeys } from './keys'

type UseInvoiceIssuesQueryData = Awaited<ReturnType<typeof getInvoiceIssues>>
type UseInvoiceIssuesQueryKey = typeof invoiceIssuesKeys.all

type UseInvoiceIssuesQueryOptions = Partial<
  UseQueryOptions<
    UseInvoiceIssuesQueryData,
    Error,
    UseInvoiceIssuesQueryData,
    UseInvoiceIssuesQueryKey
  >
>

export const useInvoiceIssuesQuery = (
  options: UseInvoiceIssuesQueryOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: invoiceIssuesKeys.all,
    queryFn: getInvoiceIssues,
  })
}
